exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-5badbb6e] {\n  resize: none;\n}", ""]);

// exports
